import React from "react";

function RightArrow({className, color}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      fill="none"
      viewBox="0 0 8 14"
      className={className}
    >
      <path
        stroke={color || "#fff"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1 13l6-6-6-6"
      ></path>
    </svg>
  );
}

export default RightArrow;